import JsonApiDecorator from '../json-api/JsonApiDecorator';
import { connect } from "react-redux";
import { camelCase, upperFirst } from 'lodash';
export { ContainerContext } from './ContainerContext';
export { default as createContainer } from './createContainer';

export const buildGenericProps = (state, type, include) => {
  let apiStore = new JsonApiDecorator(state.api);
  let props;
  if (!apiStore[type]){
    props = { [type]: [] }
    props.showAlertMessage = true;
  } else {
    const collection = apiStore[type].all(include);
    const collectionMeta = state.api[type].meta;
    props = {
      collection,
      [type]: collection,
      collectionMeta,
      [`${type}Meta`]: collectionMeta
    };
    props.showAlertMessage = true;
    if (state.api.currentEntityId && state.api.currentEntityId !== 'add'){
      props.currentEntity = apiStore[type].find(state.api.currentEntityId, include);
      props.showAlertMessage = false;
    }
  }
  const { activePage, activeFilters, activeSort, activeSearch, activeState } = state.api;
  props = { ...props, activePage, activeFilters, activeSort, activeSearch, activeState };
  if (state.api.currentEntityId === 'add'){
    props.currentEntity = apiStore.newObject(type);
    props.showAlertMessage = false;
  }
  if (!props.currentEntity && state.api.currentEntity) {
    props.currentEntity = state.api.currentEntity;
  }
  const { loadingEntities } = state.api;
  if (loadingEntities){
    Object.keys(loadingEntities).forEach((key) => {
      props[`isLoading${upperFirst(camelCase(loadingEntities[key]))}`] = true;
    });
    props.isLoadingData = Object.values(loadingEntities).includes(type);
  }
  props.errorMessage = state.api.errorMessage;
  props.errorMessages = state.api.errorMessages;
  props.successMessage = state.api.successMessage;
  props.downloadProcessing = state.api.downloadProcessing;
  props.downloadUrl = state.api.downloadUrl;
  props.downloadTimedOut = state.api.downloadTimedOut;
  return props;
};

export const connectGenericProps = config => {
  const mapGenericProps = (state, ownProps) => {
    if (typeof config === 'function') {
      config = config(ownProps);
    }
    const { entity, includes } = config;
    const genericProps = buildGenericProps(state, entity, includes);
    const apiStore = new JsonApiDecorator(state.api);
    const { route, params, location, routeParams } = ownProps;
    const props = {
      ...genericProps,
      config,
      apiStore,
      route,
      params,
      location,
      routeParams
    };
    const stateProps = typeof config.mapStateToProps === 'function' ?
      config.mapStateToProps(state, props) : {};
    return {
      ...props,
      ...stateProps
    };
  }
  
  return connect(mapGenericProps);
}
